import { render, staticRenderFns } from "./ScanErrorsModal.vue?vue&type=template&id=24d98f59"
import script from "./ScanErrorsModal.vue?vue&type=script&lang=js"
export * from "./ScanErrorsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports